//以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";

/**
 * @function  获取合作方列表
 */
export function getManagementList(data) {
  return request({
    url: `/autoapp-default-server-recovery/api/user-partnership/getAllPartnership`,
    method: "post",
    data
  });
}

/**
 * @function  获取用户订单区域管理、列表
 */
export function getOrderAreaList(data) {
  return request({
    url: `${baseService}/api/area-management/user-order/page`,
    method: "post",
    data
  });
}

/**
 * @function  批量删除
 */
export function  bathDel(data) {
  return request({
    url: `${baseService}/api/area-management/user-order/delete?idList=${data}`,
    method: "get"
  });
}


/**
 * @function  获取回收品类列表
 */
export function getRecycleCategoryList() {
  return request({
    url: `${baseService}/api/tbl-splb-dalei/getTblSplbDalei`,
    method: "get",
  });
}

/**
 * @function  保存用户订单区域管理信息（新增或编辑）
 */
export function saveUserOrderArea(data) {
  return request({
    url: `${baseService}/api/area-management/user-order/save`,
    method: "post",
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/recoveryManagement.js